import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { DonutChart } from 'components/chart/lazy'

const DonutChartContainer = ({ assetAllocationData = [], title = 'Asset Allocation', height = 450 }) => {
  // Transform data from { name, percentage, color } to { category, value, color }
  const chartData = useMemo(() => {
    if (!assetAllocationData || assetAllocationData.length === 0) {
      return []
    }

    return assetAllocationData.map((item) => ({
      category: item.name,
      value: item.percentage,
      color: item.color
    }))
  }, [assetAllocationData])

  return (
    <DonutChart
      data={chartData}
      height={height}
    />
  )
}

DonutChartContainer.propTypes = {
  assetAllocationData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      percentage: PropTypes.number.isRequired,
      color: PropTypes.string
    })
  ),
  title: PropTypes.string,
  height: PropTypes.number
}

DonutChartContainer.defaultProps = {
  assetAllocationData: [],
  title: 'Asset Allocation',
  height: 450
}

export default DonutChartContainer
